const smokingDisplayOptions = [
  { value: '0', label: 'Select', exp: 'Select' },
  { value: '1', label: 'Current Smoker' },
  { value: '2', label: 'Never Smoked'},
  { value: '3', label: 'Previously Smoked'},
  { value: '4', label: 'Unknown'},
]

export default smokingDisplayOptions
